import { useReducer } from 'react';

const reducer = (stack, action) => {
  switch (action.type) {
    case 'PUSH':
      return [...stack, { view: action.view, props: action.props || {} }];
    case 'POP':
      return stack.length > 1 ? stack.slice(0, -1) : stack;
    case 'RESET':
      return [stack[0]];
    default:
      return stack;
  }
};

export default function useModalNavigation(initialView = 'main') {
  const [stack, dispatch] = useReducer(reducer, [{ view: initialView, props: {} }]);
  return {
    current: stack[stack.length - 1],
    isRoot: stack.length === 1,
    push: (view, props) => dispatch({ type: 'PUSH', view, props }),
    pop: () => dispatch({ type: 'POP' }),
    reset: () => dispatch({ type: 'RESET' }),
  };
}
